import creditCards from 'constants/creditCards'

const identify = (
  cardNumber,
  permittedFlags = creditCards.CARD_FLAG_PATTERN_STANDARD_VALIDATION,
) => {
  const cardNumberDiff = cardNumber?.replace(/[^0-9]+/g, '')

  if (cardNumberDiff) {
    for (const flagId in permittedFlags) {
      if (permittedFlags[flagId].test(cardNumberDiff)) {
        return Number(flagId)
      }
    }
  }

  return null
}

export default identify
